import {
  Box, Button, Flex, Text
} from '@huspy/briks-web';
import { Collapse } from '@mantine/core';
import { ChevronUp, ChevronDown } from '@huspy/briks-icons';
import { ReactNode } from 'react';
import { useDisclosure } from '@mantine/hooks';

export const FormSection = ({ applicantName, children }:{ applicantName: string, children: ReactNode }) => {
  const [opened, { toggle }] = useDisclosure(true);
  return (
    <Box
      p='4'
      border='1px solid '
      bg='bg-secondary'
      borderColor='neutral.100'
      borderRadius='4'
    >
      <Flex justify='space-between' align='center' gap='2'>
        <Flex justify='center' gap='2' align='center'>
          <Flex flexDirection='column'>
            <Text fontSize='xl' fontWeight='medium'>
              {applicantName}
            </Text>
          </Flex>
        </Flex>
        <Flex gap='2'>
          <Button
            onClick={ toggle }
            size='xs'
            variant='subtle'
            borderRadius='50%'
          >
            {opened ? (
              <ChevronUp color='black' />
            ) : (
              <ChevronDown color='black' />
            )}
          </Button>
        </Flex>
      </Flex>
      <Collapse in={ opened }>
        {children}
      </Collapse>
    </Box>
  );
};
